@if (loaded()) {
  <div class="chat-wrapper">
    @if (showHeader()) {
      <div
        class="flex items-center justify-between w-full"
        [style.background-color]="headerColor"
        style="
          padding: 1.25rem 16px;
          height: 105px;
          box-sizing: border-box;
        "
      >
        <div class="flex items-center gap-3">
          <h3 class="text-white text-4xl">{{ 'CHAT.TITLE' | translate }}</h3>
        </div>
      </div>
    }
    <app-nexa-chat
      #chat
      class="flex-1 min-h-0"
      [token]="accessToken()"
      [intro]="chatIntro()"
      [standalone]="isStandalone()"
      [subTenantId]="subTenantId()"
      [subTenantName]="subTenantName()"
      [userType]="accessType() === 'private' ? 'user' : 'default'"
    ></app-nexa-chat>
  </div>
} @else {
  <div style="padding: 20px; text-align: center;">
    <p>{{ 'CHAT.LOADING' | translate }}</p>
  </div>
}
